<template>
    <v-card class="rounded-0 elevation-0 pa-3" :color="$vuetify.theme.dark ? '#172233' : '#E8F1F8'">
        <v-sheet class="transactionTable depositTabTable" :color="$vuetify.theme.dark ? '#1A2A3E ' : '#F1F7FB'">
            <v-data-table :headers="headers" :items="admins?.data" :search="search" :items-per-page="10">
                <template v-slot:item.sl="{ item, index }">
                    {{ index + 1 }}
                </template>

                <template v-slot:item.country_access="{ item }">
                    <v-tooltip bottom color="black">
                        <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on">
                                {{ formatCountryAccess(item.country_access) }}
                            </span>
                        </template>
                        <span>{{ formatTooltipCountryAccess(item.country_access) }}</span>
                    </v-tooltip>
                </template>

                <template v-slot:item.access_type="{ item }">
                    {{ item.access_type === 'manager' ? 'Manager' : item.access_type === 'admin' ? 'Admin' :
                        'Manager' }}
                </template>

                <template v-slot:item.details="{ item }">
                    <div v-if="isAdmin" class="d-flex align-center justify-end">
                        <div class="gradient-text" @click="copy(item)" v-if="item.access_type == 'manager'">
                            <span style="color: #039DE9; padding: 0 5px;">Copy BDM Link</span>
                        </div>
                        
                        <div class="links text-decoration-none mr-3">
                            <div @click="openDialog(item)">
                                <v-icon class="btn-action" color="#039de9" small>
                                    mdi-pencil-outline
                                </v-icon>
                            </div>
                        </div>
                        
                        <!-- Edit Admin Dialog -->
                        <v-dialog transition="scale-transition" origin="center center" scrollable max-width="784px" v-model="dialog[item.adminId]" class="custom-dialog">
                            <v-card class="rounded-0 px-0" :class="$vuetify.theme.dark
                                ? 'blue-darken-1'
                                : 'white-lighten-5'
                                ">
                                <v-stepper v-model="step" class="password-stepper admin-password-stepper">

                                    <template v-if="admin.accessType === 'Custom Access' && step >= 2">
                                        <v-stepper-header class="pt-3 px-5">

                                            <template v-for="(stepNumber, index) in stepNumbers">

                                                <v-stepper-step :step="stepNumber" :complete="step > stepNumber"
                                                    :color="stepNumber === totalSteps ? '#708AA7' : 'greenMain'" />

                                                <!-- divider between steps -->
                                                <v-divider v-if="index !== stepNumbers.length - 1"
                                                    :key="'divider-' + index" />
                                            </template>

                                        </v-stepper-header>
                                    </template>


                                    <v-stepper-items>
                                        <v-stepper-content step="1" class="custom-stepper-content pt-3 px-5">
                                            <v-card-title class="pb-3 text-left justify-start pl-0">
                                                Update Manager
                                            </v-card-title>
                                            <v-card-subtitle class="mt-0 pl-0 pb-0 pr-10 text--ash">
                                                You Can Update Manager From Here
                                            </v-card-subtitle>
                                            <v-card class="deposit-form password-field admin-deposit-form" :class="$vuetify.theme.dark
                                                ? 'blue-darken-1'
                                                : 'white-lighten-5'
                                                ">
                                                <v-form ref="form">
                                                    <v-row>
                                                        <!-- First Name -->
                                                        <v-col cols="12" sm="12" md="12" lg="6">
                                                            <fieldset>
                                                                <legend>First Name</legend>
                                                                <v-text-field v-model="admin.firstName"
                                                                    label="First Name" type="text" single-line solo
                                                                    class="custom-select"></v-text-field>

                                                            </fieldset>
                                                            <span v-if="!admin.firstName && error.firstName"
                                                                style="color: red; font-size: 12px;">
                                                                {{ error.firstName }}
                                                            </span>
                                                        </v-col>

                                                        <!-- Last Name -->
                                                        <v-col cols="12" sm="12" md="12" lg="6">
                                                            <fieldset>
                                                                <legend>Last Name</legend>
                                                                <v-text-field v-model="admin.lastName"
                                                                    label="Last Name" type="text" single-line solo
                                                                    class="custom-select"></v-text-field>
                                                            </fieldset>
                                                            <span v-if="!admin.lastName && error.lastName"
                                                                style="color: red; font-size: 12px">
                                                                {{ error.lastName }}
                                                            </span>
                                                        </v-col>

                                                        <!-- ROLE -->
                                                        <v-col cols="12" sm="12" md="12" lg="6">
                                                            <fieldset>
                                                                <legend>Role*</legend>
                                                                <v-select v-model="admin.role"
                                                                    :items="loggedAdmin?.is_dev === 1 || loggedAdmin?.access_type === 'admin' ? ['Manager', 'Admin'] : ['Manager']"
                                                                    label="Select Role" solo
                                                                    class="custom-select" />
                                                            </fieldset>
                                                            <span v-if="!admin.role && error.role"
                                                                style="color:red;font-size:12px">
                                                                {{ error.role }}
                                                            </span>
                                                        </v-col>

                                                        <!-- Email -->
                                                        <v-col cols="12" sm="12" md="12" lg="6">
                                                            <fieldset>
                                                                <legend>Email</legend>
                                                                <v-text-field v-model="admin.email" label="Email"
                                                                    type="email" single-line solo
                                                                    class="custom-select"></v-text-field>
                                                            </fieldset>
                                                            <span v-if="!admin.email && error.email"
                                                                style="color: red; font-size: 12px">
                                                                {{ error.email }}
                                                            </span>
                                                        </v-col>

                                                        <!-- Password -->
                                                        <v-col cols="12" sm="12" md="12" lg="6">
                                                            <fieldset>
                                                                <legend>Password</legend>
                                                                <v-text-field v-model="admin.password"
                                                                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                                                    :type="showPassword ? 'text' : 'password'"
                                                                    @click:append="showPassword = !showPassword"
                                                                    label="********" single-line solo
                                                                    class="custom-select"></v-text-field>
                                                            </fieldset>
                                                            <span v-if="!admin.password && error.password"
                                                                style="color: red; font-size: 12px">
                                                                {{ error.password }}
                                                            </span>
                                                        </v-col>

                                                        <!-- Confirm Password -->
                                                        <v-col cols="12" sm="12" md="12" lg="6">
                                                            <fieldset>
                                                                <legend>Confirm Password</legend>
                                                                <v-text-field v-model="admin.confirmPassword"
                                                                    :append-icon="showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                                                    :type="showConfirmPassword ? 'text' : 'password'"
                                                                    @click:append="showConfirmPassword = !showConfirmPassword"
                                                                    label="********" single-line solo
                                                                    class="custom-select"></v-text-field>
                                                            </fieldset>
                                                            <span
                                                                v-if="!admin.confirmPassword && error.confirmPassword"
                                                                style="color: red; font-size: 12px">
                                                                {{ error.confirmPassword }}
                                                            </span>
                                                            <span v-if="error.passwordMatch"
                                                                style="color: red; font-size: 12px">
                                                                {{ error.passwordMatch }}
                                                            </span>
                                                        </v-col>

                                                        <!-- Country Access -->
                                                        <v-col cols="12" sm="12" md="12" lg="6">
                                                            <fieldset>
                                                                <legend>Country Access</legend>
                                                                <v-autocomplete v-model="admin.countryAccess"
                                                                    :items="countryItems" label="Country Access"
                                                                    item-text="name" item-value="id" multiple chips
                                                                    deletable-chips single-line solo
                                                                    class="custom-select" return-object
                                                                    @change="handleCountrySelection" />

                                                            </fieldset>
                                                            <span v-if="!admin.countryAccess && error.countryAccess"
                                                                style="color: red; font-size: 12px">
                                                                {{ error.countryAccess }}
                                                            </span>
                                                        </v-col>

                                                        <!-- Access Type -->
                                                        <v-col cols="12" sm="12" md="12" lg="6">
                                                            <fieldset>
                                                                <legend>Access Type</legend>
                                                                <v-select v-model="admin.accessType"
                                                                    @change="handleAccessTypeChange($event)"
                                                                    :items="['Full Control', 'Read Only', 'Custom Access']"
                                                                    label="Access Type" single-line solo
                                                                    class="custom-select"></v-select>
                                                            </fieldset>
                                                            <span v-if="!admin.accessType && error.accessType"
                                                                style="color: red; font-size: 12px">
                                                                {{ error.accessType }}
                                                            </span>
                                                        </v-col>
                                                    </v-row>


                                                    <!-- Action Buttons -->
                                                    <v-col cols="12" sm="12" md="12" lg="6" class="px-0">
                                                        <v-btn v-if="admin.accessType !== 'Custom Access'" tile
                                                            @click.prevent="submitForm()" elevation="0"
                                                            class="text-capitalize btn-account mr-3 px-sm-8"
                                                            color="greenMain" :loading="loading"
                                                            :disabled="loading">
                                                            Save
                                                        </v-btn>
                                                        <v-btn v-else class="text-capitalize btn-account"
                                                            color="greenMain" tile elevation="0" @click="nextStep">
                                                            Next Step
                                                        </v-btn>
                                                    </v-col>
                                                </v-form>
                                            </v-card>
                                        </v-stepper-content>

                                        <v-stepper-content v-for="(stepModules, index) in permissionData"
                                            :key="'perm-step-' + index" :step="index + 2"
                                            class="custom-stepper-content pt-3 px-0">

                                            <v-card-text class="title-bar px-5 pt-0">
                                                <v-card-title class="pb-1 text-left justify-start pl-0">
                                                    Custom Access
                                                    <small class="ml-1">For <span>{{ admin.firstName + ' ' +
                                                        admin.lastName
                                                            }}</span></small>
                                                </v-card-title>

                                                <v-card-subtitle class="mt-0 pl-0 pb-0 pr-10 text--ash">
                                                    Set Custom Access For Selected User
                                                </v-card-subtitle>
                                            </v-card-text>

                                            <v-form>
                                                <v-card class="deposit-form admin-deposit-form mt-0 px-0"
                                                    :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'">

                                                    <v-row no-gutters dense>
                                                        <v-col cols="12">

                                                            <div v-for="module in stepModules"
                                                                :key="'mod-' + module.moduleId"
                                                                class="custom-access-stepper">

                                                                <!-- MODULE ACCESS CONTROL -->
                                                                <v-row align="center" dense no-gutters
                                                                    class="pt-9 pb-8">
                                                                    <v-col cols="12" md="5">
                                                                        <h3>
                                                                            <v-icon color="#039de9" small
                                                                                class="mr-3">{{ module.icon
                                                                                }}</v-icon>
                                                                            {{ module.moduleName }}
                                                                        </h3>
                                                                    </v-col>

                                                                    <v-col cols="12" md="7" class="mb-5">
                                                                        <v-radio-group v-model="module.moduleAccess"
                                                                            row hide-details>
                                                                            <v-radio
                                                                                v-for="option in getModuleOptions(module)"
                                                                                :key="option" :label="option"
                                                                                :value="option" color="teal"
                                                                                class="custom-radio-buttons" />
                                                                        </v-radio-group>
                                                                    </v-col>
                                                                </v-row>

                                                                <!-- SUBMODULES -->
                                                                <v-row
                                                                    v-if="module.moduleAccess === 'Custom' && module.subModules.length > 1"
                                                                    dense no-gutters>
                                                                    <v-card-subtitle class="px-0 pt-0 pb-4">
                                                                        You are giving access to these pages
                                                                    </v-card-subtitle>

                                                                    <v-card-text class="pb-8">
                                                                        <div class="chips">
                                                                            <div v-for="sub in module.subModules"
                                                                                :key="'sub-' + sub.id"
                                                                                class="chips-details">

                                                                                <span>{{ sub.name }}</span>

                                                                                <v-select v-model="sub.access"
                                                                                    :items="['Full Control', 'Read Only', 'No Access']"
                                                                                    solo hide-details
                                                                                    append-icon="mdi-chevron-down"
                                                                                    class="custom-select" />
                                                                            </div>
                                                                        </div>
                                                                    </v-card-text>
                                                                </v-row>

                                                            </div>

                                                        </v-col>
                                                    </v-row>

                                                </v-card>

                                                <div class="px-5 py-12">
                                                    <v-btn class="btn-account mr-3" color="greenMain" tile
                                                        elevation="0" @click="prevStep">Back</v-btn>

                                                    <v-btn class="btn-account" color="greenMain" tile elevation="0"
                                                        @click="nextStep">Next
                                                        Step</v-btn>
                                                </div>

                                            </v-form>

                                        </v-stepper-content>

                                        <v-stepper-content :step="totalSteps"
                                            class="custom-stepper-content pt-3 px-5">
                                            <v-form>
                                                <v-card class="deposit-form admin-deposit-form mt-0 px-0"
                                                    :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'">

                                                    <v-row dense no-gutters>
                                                        <v-col cols="12" class="px-0">
                                                            <div class="last-steps">
                                                                <h1>Are You Sure ?</h1>
                                                                <h4>You want to save all the changes of custom
                                                                    access?</h4>
                                                            </div>

                                                            <v-img src="@/assets/login.png" max-height="207"
                                                                max-width="219" class="mx-auto mb-10"></v-img>
                                                        </v-col>
                                                    </v-row>

                                                    <div class="px-5 py-12 text-center">
                                                        <v-btn class="text-capitalize btn-account mr-3"
                                                            color="greenMain" tile elevation="0" @click="prevStep">
                                                            Back
                                                        </v-btn>

                                                        <v-btn class="text-capitalize btn-account" color="#FF567F"
                                                            tile elevation="0" :loading="loading"
                                                            :disabled="loading" @click.prevent="submitForm()">
                                                            Save & Close
                                                        </v-btn>
                                                    </div>

                                                </v-card>
                                            </v-form>
                                        </v-stepper-content>
                                    </v-stepper-items>
                                </v-stepper>
                            </v-card>
                        </v-dialog>
                        <!-- Edit Admin Dialog -->

                        <v-icon  class="btn-action" color="#FF567F" small @click="deleteItem(item)">
                            mdi-trash-can-outline
                        </v-icon>
                    </div>
                    <v-icon v-else class="btn-action" color="#039de9" small>
                        mdi-cancel
                    </v-icon>
                </template>
            </v-data-table>
        </v-sheet>
    </v-card>
</template>

<script>
import toast from "@/services/Notification";
import { ADMINS__ACTIONS, GENERALINFO__ACTIONS } from "@/store/action-types";
import { mapActions, mapState } from "vuex";

export default {
    props: {
        search: {
            type: String,
            default: "",
        }
    },

    data() {
        return {
            dialog: {},
            showPassword: false,
            loading: false,
            showConfirmPassword: false,
            headers: [
                { text: "SL", value: "sl", align: "start" },
                { text: "Name", value: "fullname" },
                { text: "Email", value: "email" },
                { text: "Role", value: "access_type" },
                { text: "Country Access", value: "country_access" },
                { text: "Action", value: "details" },
            ],
            step: 1,
            permissionData: [],
            error: {
                firstName: "",
                lastName: "",
                email: "",
                password: "",
                confirmPassword: "",
                countryAccess: "",
                role: "",
                accessType: "",
                passwordMatch: "",
            },
            admin: {},
        };
    },

    computed: {
        ...mapState("admins", ["loggedAdmin", "admins", "countries", "allModulesAndSubmodules"]),
        ...mapState("generalinfo", ["generalInfos"]),

        isAdmin() {
            return (
                this.loggedAdmin && this.loggedAdmin?.access_type === "admin"
            );
        },

        stepNumbers() {
            return Array.from({ length: this.totalSteps }, (_, i) => i + 1);
        },

        totalSteps() {
            return 1 + this.permissionData.length + 1;
        },

        countryItems() {
            return [
                { id: 'all', name: 'All Countries' },
                ...this.countries.map(c => ({
                    id: Number(c.id),
                    name: c.name
                }))
            ];
        }
    },

    watch: {
        countries: {
            handler() {
                this.buildPermissionData();
            },
            immediate: true,
        },
    },

    methods: {
        ...mapActions("admins", [
            ADMINS__ACTIONS.GETADMINS,
            ADMINS__ACTIONS.UPDATEADMIN,
            ADMINS__ACTIONS.DELETEADMIN,
            ADMINS__ACTIONS.GETROLES,
            ADMINS__ACTIONS.GETALLMODULES,
        ]),

        ...mapActions("generalinfo", [
            GENERALINFO__ACTIONS.GENERALINFO,
        ]),

        nextStep() {
            if (!this.validateStep1()) return;
            if (this.step < this.totalSteps) this.step++;
        },

        prevStep() {
            if (this.step > 1) this.step--;
        },

        validateStep1() {
            let valid = true;

            const required = [
                ["firstName", "First name field is required"],
                ["lastName", "Last name field is required"],
                ["email", "Email field is required"],
                ["role", "Role field is required"],
                ["accessType", "Access type field is required"],
            ];

            required.forEach(([field, msg]) => {
                if (!this.admin[field] || this.admin[field].trim() === "") {
                    this.error[field] = msg;
                    valid = false;
                } else this.error[field] = null;
            });

            if (!this.admin.countryAccess) {
                this.error.countryAccess = "Country access field is required";
                valid = false;
            } else this.error.countryAccess = null;

            if (this.admin.password || this.admin.confirmPassword) {
                if (this.admin.password !== this.admin.confirmPassword) {
                    this.error.passwordMatch = "Passwords do not match";
                    valid = false;
                } else {
                    this.error.passwordMatch = null;
                }
            }

            return valid;
        },

        resetModal() {
            this.step = 1;
            this.admin = {
                id: null,
                firstName: "",
                lastName: "",
                email: "",
                role: "",
                countryAccess: [],
                accessType: "",
                password: "",
                confirmPassword: ""
            };
            this.error = {};
        },

        handleCountrySelection(selection) {
            if (!selection) {
                this.admin.countryAccess = [];
                return;
            }

            if (selection.includes("all")) {
                this.admin.countryAccess = ["all"];
                return;
            }
            this.admin.countryAccess = selection.filter((s) => s !== "all");
        },

        openDialog(item) {
            this.step = 1;
            let countryAccess = [];
            if (item.country_access === "all") {
                countryAccess = [{ id: 'all', name: "All Countries" }];
            } else if (item.country_access) {
                const names = item.country_access.split(',').map(n => n.trim());
                countryAccess = names
                    .map(name => {
                        const c = this.countries.find(x => x.name == name);
                        return c ? { id: Number(c.id), name: c.name } : null;
                    })
                    .filter(Boolean);
            }
   
            const newAdmin = {
                id: item.adminId,
                firstName: item.fullname?.split(" ")[0] || "",
                lastName: item.fullname?.split(" ")[1] || "",
                email: item.email,
                role: item.access_type === "admin" ? "Admin" : "Manager",
                countryAccess,
                accessType: "Custom Access"
            };

            this.$nextTick(() => {
                this.admin = JSON.parse(JSON.stringify(newAdmin));
                this.loadExistingPermissions(item.permissions);
            });
      
            this.$set(this.dialog, item.adminId, true);
        },

        applyGlobalAccess(accessValue) {
            if (!this.permissionData || this.permissionData.length === 0) return;

            this.permissionData.forEach(group => {
                group.forEach(module => {
                    module.moduleAccess =
                        accessValue === 1 ? "Full Control" :
                            accessValue === 2 ? "Read Only" : "No Access";

                    module.subModules.forEach(sub => {
                        sub.access =
                            accessValue === 1 ? "Full Control" :
                                accessValue === 2 ? "Read Only" : "No Access";
                    });

                });
            });
        },

        handleAccessTypeChange(newValue) {
            if (newValue === "Full Control") {
                this.applyGlobalAccess(1);
            }
            else if (newValue === "Read Only") {
                this.applyGlobalAccess(2);
            }
        },

        buildPermissionData() {
            if (!Array.isArray(this.allModulesAndSubmodules)) {
                return;
            }
            const modules = this.allModulesAndSubmodules;
            const chunkSize = 500;
            const temp = [];

            modules.forEach((module) => {
                temp.push({
                    moduleId: Number(module.id),
                    moduleName: module.module,
                    icon: module.icon,
                    moduleAccess: "No Access",
                    subModules: module.subModules.map((sub) => ({
                        id: Number(sub.id),
                        name: sub.name,
                        access: "No Access",
                    })),
                });
            });

            const chunks = [];
            for (let i = 0; i < temp.length; i += chunkSize) {
                chunks.push(temp.slice(i, i + chunkSize));
            }

            this.permissionData = chunks;
        },

        loadExistingPermissions(savedPermissions) {
            if (!savedPermissions) return;

            this.permissionData = this.permissionData.map(group =>
                group.map(module => {

                    const moduleId = Number(module.moduleId);
                    const saved = savedPermissions[moduleId];

                    if (!saved) return module;

                    module.subModules = module.subModules.map(sub => {
                        const subId = Number(sub.id);
                        const savedAccess = saved.subModules[subId];

                        return {
                            ...sub,
                            access:
                                savedAccess === 1 ? "Full Control"
                                    : savedAccess === 2 ? "Read Only"
                                        : savedAccess === 3 ? "Custom Access"
                                            : "No Access"
                        };
                    });

                    // --- Derive moduleAccess based on submodules ----
                    if (module.subModules.length > 1) {
                        // Multiple submodules always = Custom Access
                        module.moduleAccess = "Custom";
                    } else if (module.subModules.length === 1) {
                        // One submodule → inherit its access
                        let single = module.subModules[0].access;

                        module.moduleAccess = single; // SAME STRING VALUE
                    } else {
                        // No submodule? fallback
                        module.moduleAccess = "No Access";
                    }

                    return module;
                })
            );
        },

        getModuleOptions(module) {
            if (module.subModules.length > 1) {
                return ["Full Control", "Read Only", "No Access", "Custom"];
            }
            return ["Full Control", "Read Only", "No Access"];
        },

        mapAccess(text) {
            switch (text) {
                case "Full Control":
                    return 1;
                case "Read Only":
                    return 2;
                case "Custom":
                    return 3;
                case "No Access":
                    return 0;
                default:
                    return 0;
            }
        },

        buildPermissionPayload() {
            const output = {};

            this.permissionData.forEach((group) => {
                group.forEach((module) => {
                    const moduleAccess = this.mapAccess(module.moduleAccess);

                    const subPayload = {};
                    module.subModules.forEach((sub) => {
                        subPayload[sub.id] =
                            module.moduleAccess === "Custom"
                                ? this.mapAccess(sub.access)
                                : moduleAccess;
                    });

                    output[module.moduleId] = {
                        access: moduleAccess,
                        subModules: subPayload,
                    };
                });
            });

            return output;
        },

        submitForm() {
            if (!this.validateStep1()) return;
            this.loading = true;
            try {
                const formattedCountryAccess = this.admin.countryAccess.some((c) => c.id === 'all') ? this.countries.map((c) => c.id).join(",") : this.admin.countryAccess.map((c) => c.id).join(",");
                const permissions = this.buildPermissionPayload();
                const data = {
                    adminData: {
                        id: this.admin.id,
                        firstName: this.admin.firstName,
                        lastName: this.admin.lastName,
                        email: this.admin.email,
                        countryAccess: formattedCountryAccess,
                        role: this.admin.role.toLowerCase(),
                        password: this.admin.password,
                        accessType:
                            this.admin.accessType === "Full Control"
                                ? 1
                                : this.admin.accessType === "Read Only"
                                    ? 2
                                    : 3,
                    },
                    permissions,
                };

                this[ADMINS__ACTIONS.UPDATEADMIN](data)
                 
            } catch (error) {
                console.error("Error submitting form:", error);
            } finally {
                this.loading = false;
                this.handleClose(this.admin.id);
            }
        },

        handleClose(id) {
            this.$set(this.dialog, id, false);
        },

        copy(item) {
            if (!this.generalInfos?.client_portal_url) {
                toast.info('Client portal URL not found');
                return;
            }

            const bdm_Link = `${this.generalInfos.client_portal_url}/registration?referred_by_manager=${item.adminId}`;

            navigator.clipboard.writeText(bdm_Link)
                .then(() => {
                    toast.success('BDM link copied to clipboard!');
                })
                .catch(err => {
                    toast.info('Failed to copy link');
                });
        },

        formatCountryAccess(countries) {
            if (!countries) return '';
            const countryList = countries.split(',');
            if (countryList.length > 3) {
                return countryList
                    .slice(0, 3)
                    .map(country => country.trim().charAt(0).toUpperCase() + country.trim().slice(1))
                    .join(', ') + ' ...';
            }
            return countryList
                .map(country => country.trim().charAt(0).toUpperCase() + country.trim().slice(1))
                .join(', ');
        },

        formatTooltipCountryAccess(countries) {
            if (!countries) return '';
            const countryList = countries.split(',');
            if (countryList.length > 5) {
                return countryList
                    .slice(0, 5)
                    .map(country => country.trim().charAt(0).toUpperCase() + country.trim().slice(1))
                    .join(', ') + `, and ${countryList.length - 5} more countries`;
            }
            return countryList
                .map(country => country.trim().charAt(0).toUpperCase() + country.trim().slice(1))
                .join(', ');
        },

        deleteItem(item) {
            const confirmed = window.confirm(
                "Are you sure you want to delete this Manager?"
            );
            if (confirmed) {
                if (this.isAdmin || this.loggedAdmin.is_dev === 1) {
                    this[ADMINS__ACTIONS.DELETEADMIN]({ id: item.adminId });
                } else {
                    toast.info("You don't have permission to delete!");
                }
            }
        },
    },

    async created() {
        await this[ADMINS__ACTIONS.GETADMINS]();
        await this[GENERALINFO__ACTIONS.GENERALINFO]();
        await this[ADMINS__ACTIONS.GETROLES]();
        await this[ADMINS__ACTIONS.GETALLMODULES]();
    },
};
</script>

<style scoped>
    .gradient-text {
        cursor: pointer;
        color: turquoise;
        border: 2px solid transparent;
        border-image: linear-gradient(91.16deg, #ff567f .27%, #fff 52.01%, #14d7b2 99.06%) 1;
        margin-right: 10px;
    }

    .custom-dialog .v-card {
        max-height: 100vh;
        overflow-y: auto;
    }

    .custom-stepper-content {
        max-height: calc(100vh - 150px);
        overflow-y: auto;
        padding-bottom: 16px;
    }

    .btn-action{
        cursor: pointer;
    }

    .btn-action:hover{
        font-size: 18px !important;
    }
</style>